import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const Vaccination: FC = () => {
  return (
    <Box mt={1}>
        <Header>
            <Box>
                <TextField
                    label="Дата вакцинации"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, mr: 2 }}
                />
                <FormControlLabel
                    label="Ревакцинация проведена"
                    control={<Checkbox defaultChecked />}
                />
            </Box>
            <Box>
                <TextField
                    label="Предварительная дата ревакцинации 1"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1, mr: 2  }}
                />
                <FormControlLabel
                    label="Ревакцинация проведена"
                    control={<Checkbox defaultChecked />}
                />
            </Box>
            <Box>
                <TextField
                    label="Предварительная дата ревакцинации 2"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1, mr: 2  }}
                />
                    <FormControlLabel
                    label="Ревакцинация проведена"
                    control={<Checkbox defaultChecked />}
                />
            </Box>
            <Box>
                <TextField
                    label="Предварительная дата ревакцинации 3"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1, mr: 2  }}
                />
                    <FormControlLabel
                    label="Ревакцинация проведена"
                    control={<Checkbox defaultChecked />}
                />
            </Box>
            <Box>
                <TextField
                    label="Предварительная дата ревакцинации 4"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1, mr: 2  }}
                />
                    <FormControlLabel
                    label="Ревакцинация проведена"
                    control={<Checkbox defaultChecked />}
                />
            </Box>
            <Box>
                <TextField
                    label="Предварительная дата ревакцинации 5"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1, mr: 2  }}
                />
                    <FormControlLabel
                    label="Ревакцинация проведена"
                    control={<Checkbox defaultChecked />}
                />
            </Box>
        </Header>
      <Body>

      </Body>
    </Box>
  );
};

export default Vaccination;
